import React from "react";
import type { BulkTargets, FormIdListResult, SchoolFormId } from "../types";

export type BulkTargetsResult =
  | { targets: BulkTargets }
  | { targets: null; reason: "no-selection" | "empty-list" };

export type FetchAllIds = () => Promise<FormIdListResult>;

type BulkActionTargets = {
  loadTargets: () => Promise<SchoolFormId[]>;
  resolveTargets: () => Promise<BulkTargetsResult>;
  selectionSize: number;
  clearSelection: () => void;
};

export const BulkActionTargetsContext =
  React.createContext<BulkActionTargets | null>(null);

export function useBulkActionTargets() {
  const ctx = React.useContext(BulkActionTargetsContext);
  if (!ctx) {
    throw new Error(
      "useBulkActionTargets must be used within BulkActionTargetsProvider"
    );
  }
  return ctx;
}
